import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import {
  getClinicians,
  getClinician,
  createClinician,
  updateClinician,
  deleteClinician,
  clearLocalClinicians,
  clearLocalActiveClinician
} from './actions';

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  clinician: { 
    id: '', 
    first_name: '', 
    last_name: '', 
    display_name: '', 
    locations: [], 
    injuries: [], 
    prompt: '', 
    filter_prompt: '',
    merge_prompt: '',
    synchronized: false, 
    slots_count: 0,
    updated_at: '' 
  },
  loading: { 
    all: false, 
    clinician: false 
  }
};

const  slice = createSlice({
  name: 'clinicians',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getClinicians.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getClinicians.fulfilled, (state, action) => {
        const { clinicians, pagination } = action.payload;
        
        state.loading.all = false;
        state.all.data = [...state.all.data, ...clinicians];
        state.all.pagination = pagination;
      })
      .addCase(getClinicians.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getClinician.pending, (state) => {
        state.loading.clinician = true;
      })
      .addCase(getClinician.fulfilled, (state, action) => {
        const { clinician } = action.payload;
        const foundedClinician = !!_find(state.all.data, (m) => m.id === clinician.id);
        const updatedClinician = { ...state.clinician, ...clinician };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedClinician ? _map(state.all.data, (m) => m.id === clinician.id ? { ...m, ...clinician } : m) : [...[clinician], ...oldAllData]; 
        const pagination = foundedClinician ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.clinician = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedClinician) state.clinician = updatedClinician;       
      })
      .addCase(getClinician.rejected, (state) => {
        state.loading.clinician = false;
      })
      .addCase(createClinician.pending, (state) => {
        state.loading.clinician = true;
      })
      .addCase(createClinician.fulfilled, (state, action) => {
        const { clinician } = action.payload;
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = [...[clinician], ...oldAllData];
        const pagination = { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.clinician = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        state.clinician = clinician;
      })
      .addCase(createClinician.rejected, (state) => {
        state.loading.clinician = false;
      })
      .addCase(updateClinician.pending, (state) => {
        state.loading.clinician = true;
      })
      .addCase(updateClinician.fulfilled, (state, action) => {
        const { status, clinician } = action.payload;
        const data = _map(state.all.data, (m) => m.id === clinician.id ? { ...m, ...clinician } : m)
        const updatedClinician = { ...state.clinician, ...clinician, ...(!!clinician.localLocations && {locations: clinician.localLocations}) };
        
        state.loading.clinician = false;
        if (status === 204) {
          state.all.data = data;
          state.clinician = updatedClinician;
        }     
      })
      .addCase(updateClinician.rejected, (state) => {
        state.loading.clinician = false;
      })
      .addCase(deleteClinician.pending, (state) => {
        state.loading.clinician = true;
      })
      .addCase(deleteClinician.fulfilled, (state, action) => {
        const { status, id } = action.payload;
        
        state.loading.clinician = false;
        if (status === 204) {
          state.all.data = _filter(state.all.data, (item) => item.id !== id);
          state.all.pagination = { ...state.all.pagination, count: state.all.pagination.count - 1, total_count: state.all.pagination.total_count - 1 };
          state.clinician = initialState.clinician;
        }
      })
      .addCase(deleteClinician.rejected, (state) => {
        state.loading.clinician = false;
      })
      .addCase(clearLocalClinicians, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveClinician, state => {
        state.clinician = initialState.clinician;
      })
  }
})

export default slice.reducer;